/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FxIdApplicationCrossPlayHandlersEventRuleDTO,
  FxIdApplicationCrossPlayHandlersUserQuestDto,
  FxIdWebFeaturesCrossPlaySendInGameEventRequest,
} from '../models/index';
import {
    FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSON,
    FxIdApplicationCrossPlayHandlersEventRuleDTOToJSON,
    FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSON,
    FxIdApplicationCrossPlayHandlersUserQuestDtoToJSON,
    FxIdWebFeaturesCrossPlaySendInGameEventRequestFromJSON,
    FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSON,
} from '../models/index';

export interface FxIdWebFeaturesCrossPlayGetEventRulesEndpointRequest {
    game: string;
}

export interface FxIdWebFeaturesCrossPlaySendInGameEventEndpointRequest {
    fxIdWebFeaturesCrossPlaySendInGameEventRequest: FxIdWebFeaturesCrossPlaySendInGameEventRequest;
}

/**
 * 
 */
export class CrossPlayApi extends runtime.BaseAPI {

    /**
     */
    async fxIdWebFeaturesCrossPlayGetEventRulesEndpointRaw(requestParameters: FxIdWebFeaturesCrossPlayGetEventRulesEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FxIdApplicationCrossPlayHandlersEventRuleDTO>>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesCrossPlayGetEventRulesEndpoint().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['game'] != null) {
            queryParameters['Game'] = requestParameters['game'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/cross-play/events/rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSON));
    }

    /**
     */
    async fxIdWebFeaturesCrossPlayGetEventRulesEndpoint(game: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FxIdApplicationCrossPlayHandlersEventRuleDTO>> {
        const response = await this.fxIdWebFeaturesCrossPlayGetEventRulesEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fxIdWebFeaturesCrossPlayGetMyQuestsEndpointRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FxIdApplicationCrossPlayHandlersUserQuestDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/cross-play/quests/my`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSON));
    }

    /**
     */
    async fxIdWebFeaturesCrossPlayGetMyQuestsEndpoint(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FxIdApplicationCrossPlayHandlersUserQuestDto>> {
        const response = await this.fxIdWebFeaturesCrossPlayGetMyQuestsEndpointRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async fxIdWebFeaturesCrossPlaySendInGameEventEndpointRaw(requestParameters: FxIdWebFeaturesCrossPlaySendInGameEventEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['fxIdWebFeaturesCrossPlaySendInGameEventRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesCrossPlaySendInGameEventRequest',
                'Required parameter "fxIdWebFeaturesCrossPlaySendInGameEventRequest" was null or undefined when calling fxIdWebFeaturesCrossPlaySendInGameEventEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/cross-play/events/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesCrossPlaySendInGameEventRequestToJSON(requestParameters['fxIdWebFeaturesCrossPlaySendInGameEventRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fxIdWebFeaturesCrossPlaySendInGameEventEndpoint(fxIdWebFeaturesCrossPlaySendInGameEventRequest: FxIdWebFeaturesCrossPlaySendInGameEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fxIdWebFeaturesCrossPlaySendInGameEventEndpointRaw({ fxIdWebFeaturesCrossPlaySendInGameEventRequest: fxIdWebFeaturesCrossPlaySendInGameEventRequest }, initOverrides);
    }

}
